/** Age-friendly defaults when an activity omits `hints` in JSON. */
export const GENERIC_GUIDED_HINTS = [
  {
    text: 'Take a slow breath, then look at the activity again — clues are often hiding in plain sight.',
    audioText:
      'Take a slow breath, then look at the activity again — clues are often hiding in plain sight.',
    level: 1,
  },
  {
    text: 'Read the question out loud in your head. What is it really asking you to do?',
    audioText: 'Read the question out loud in your head. What is it really asking you to do?',
    level: 2,
  },
  {
    text: 'Try one small move: cross off a choice that does not fit, or match one pair you feel sure about.',
    audioText:
      'Try one small move: cross off a choice that does not fit, or match one pair you feel sure about.',
    level: 3,
  },
];

/**
 * @param {unknown} rawHints
 * @returns {{ text: string, audioText: string, level: number }[]}
 */
export function normalizeGuidedHints(rawHints) {
  const useGeneric = !Array.isArray(rawHints) || rawHints.length === 0;
  const src = useGeneric ? GENERIC_GUIDED_HINTS : rawHints;
  const out = src
    .map((h, i) => {
      if (typeof h === 'string') {
        const text = h.trim();
        return { text, audioText: text, level: i + 1 };
      }
      if (h && typeof h === 'object') {
        const text = typeof h.text === 'string' ? h.text.trim() : '';
        const audioRaw = typeof h.audioText === 'string' ? h.audioText.trim() : '';
        const audioText = audioRaw || text;
        const level =
          typeof h.level === 'number' && h.level >= 1 ? Math.floor(h.level) : i + 1;
        return { text, audioText, level };
      }
      return { text: '', audioText: '', level: i + 1 };
    })
    .filter((x) => x.text.length > 0);

  if (!useGeneric && out.length === 0) {
    return normalizeGuidedHints([]);
  }
  return out;
}

/**
 * @param {{ text: string, audioText: string, level: number }[]} normalized
 * @param {number} visibleLevel 1-based
 */
export function hintEntryAtLevel(normalized, visibleLevel) {
  if (!normalized.length) return null;
  const idx = Math.min(normalized.length, Math.max(1, visibleLevel)) - 1;
  return normalized[idx];
}

export const GUIDED_HINT_INACTIVITY_MS = 12_000;
export const GUIDED_HINT_WRONG_BEFORE_EXPLANATION = 3;
